import React from 'react';
import { Image } from 'semantic-ui-react'

interface TemplateProps {
  onDragStart: (e: React.DragEvent<HTMLDivElement>) => void;
  template: any;
}

export function Template(props: TemplateProps){
  return (
    <div 
      className={`template ${props.template.type}`}
      draggable
      onDragStart={props.onDragStart}
    >
      <Image src={props.template.portrait} />
    </div>
  );
}
